import React from 'react';
import Plot from 'react-plotly.js';
import api_data from '../../data/TableData';

export default function CreatedAtGraph(props) {
    const products= api_data["Demonstration"]

    return (
        <div className="ContainerGraph">
            <Plot
                data={[{
                    type: 'bar',
                    x: products.map((e) => e.expirate),
                    // x: products.map((e) => (e.date)),
                    y: products.map((e) => (e.quantity)),
                }]}
                layout={{
                    width: 625,
                    height: 500,
                    autoscale: false,
                    title: 'Demonstrações que irão expirar',
                    'xaxis': { 'tickformat': '%b-%y'},
                    font: {
                        family: '"Roboto","Helvetica","Arial",sans-serif',
                        size: 16,
                        color: '#7f7f7f'
                    }
                }}
                config={{
                    displayModeBar: true,
                    staticPlot: false,
                    rangemode: 'tozero',
                }}
            />
        </div>
    )

}